import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { Order } from 'depoto-core/src/entities'

@Component({
  selector: 'app-order-product-moves',
  templateUrl: './order-product-moves.component.html',
  styleUrls: ['order-product-moves.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderProductMovesComponent {
  @Input() order: Order
}
